import { Link } from 'react-router';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

function AiToolCard({ prompt }) {
    return (
        <Link
            className='bg-white group block overflow-hidden w-full border border-1 rounded-xl hover:border-blue-600'
            to={`/tools/${prompt.type}/${prompt.id}`}>
            <div className='flex flex-col p-4 gap-4'>
                <div className='w-full gap-2 flex items-center justify-start'>
                    <span className='text-3xl'>{prompt.emoji}</span>
                    <p className='text-ellipsis max-w-64 whitespace-nowrap overflow-hidden mt-2  text-gray-900 sm:mt-3 text-lg md:text-xl font-pj'>
                        {prompt.title}
                    </p>
                </div>
                <p className='text-gray-600 h-20'>{prompt.description}</p>
                <Button variant='outline'>
                    Try Now
                    <ArrowRight />
                </Button>
            </div>
        </Link>
    );
}

export default function PromptsListing({ title, description, prompts }) {
    return (
        <section className='py-10 bg-white sm:py-16 lg:py-24'>
            <div className='px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl'>
                <div className='max-w-2xl mx-auto text-center'>
                    <h1 className='capitalize text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-5xl'>
                        Free AI {title} tools
                    </h1>
                    <p className='max-w-xl mx-auto mt-4 text-base leading-relaxed text-gray-600'>
                        {description}
                    </p>
                </div>

                <div className='grid max-w-md grid-cols-1 mx-auto mt-12 lg:max-w-full lg:mt-16 lg:grid-cols-3 gap-x-16 gap-y-12'>
                    {prompts.map((p) => (
                        <AiToolCard key={p.id} prompt={p} />
                    ))}
                </div>
            </div>
        </section>
    );
}
